<template>
  <v-card :color="getCardColor">
    <v-card-text>
      <div v-if="loading">
        <v-progress-circular
          indeterminate
          size="20"
          color="primary"
          class="mr-2 d-inline-block align-middle"
        ></v-progress-circular>
        <span>Chargement des données...</span>
      </div>
      <div v-else-if="error">
        <v-icon color="error" small class="mr-2 d-inline-block align-middle">error</v-icon>
        <span>{{ error }}</span>
      </div>
      <div v-else>
        <span>
          Nombre de codes 
          <i>Oxford placement test</i> 
          restants : <strong>{{ oxfordPlacementTest.remaining || 0 }}</strong>
        </span>
        <v-icon 
          small 
          style="margin-left: 6px; vertical-align: middle; cursor: pointer;"
          @click="loadData" 
          :style="loading ? 'opacity: 0.5; cursor: not-allowed;' : ''"
        >
          refresh
        </v-icon>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'OxfordPlacementTestCount',
  props: {
    warningThreshold: {
      type: Number,
      default: 50
    },
    criticalThreshold: {
      type: Number,
      default: 10
    }
  },
  data: () => ({
    loading: false,
    error: null,
    oxfordPlacementTest: {
      remaining: null,
    },
  }),
  computed: {
    getCardColor() {
      const remaining = this.oxfordPlacementTest.remaining;
      if (remaining === undefined || remaining === null) {
        return 'grey lighten-3';
      } else if (remaining >= this.warningThreshold) {
        return 'green lighten-5';
      } else if (remaining >= this.criticalThreshold) {
        return 'orange lighten-5';
      } else {
        return 'red lighten-5';
      }
    },
  },
  async mounted() {
    await this.loadData();
  },
  methods: {
    async loadData() {
      if (this.loading) return;
      
      this.loading = true;
      this.error = null;
      
      try {
        const response = await this.fetchRemainingTests();
        this.oxfordPlacementTest.remaining = response.remaining;
      } catch (error) {
        //eslint-disable-next-line no-console
        console.error('Error fetching Oxford placement tests:', error);
        this.error = 'Impossible de récupérer les données des tests disponibles';
      } finally {
        this.loading = false;
      }
    },
    async fetchRemainingTests() {
      const endpoint = `${process.env.VUE_APP_API_URI}/oxford-placement-tests/remaining`;
      const response = await fetch(endpoint, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${this.$keycloak.token}`,
          'Content-Type': 'application/json',
        },
      });
      
      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(
          errorData.message || `Échec de la requête avec le statut ${response.status}`
        );
      }
      
      return response.json();
    },
  },
};
</script>
